import { MutableRefObject, useEffect, useMemo, useRef, useState } from 'react';

type HookResult = [
  MutableRefObject<HTMLImageElement | null>,
  boolean,
  [number, number]
]

export function useImage(url?: string): HookResult {
  const [loaded, setLoaded] = useState<string>('');
  const [size, setSize] = useState<[number, number]>([0, 0]);
  const imageRef = useRef(typeof Image !== 'undefined' ? new Image() : null);

  useEffect(() => {
    if (imageRef.current) {
      const handler = () => {
        setSize([imageRef.current?.width ?? 0, imageRef.current?.height ?? 0]);
        setLoaded(imageRef.current?.src ?? '');
      }

      imageRef.current?.setAttribute('crossOrigin', 'anonymous');
      imageRef.current?.addEventListener('load', handler);

      return () => {
        imageRef.current?.removeEventListener('load', handler);
      }
    }

    return () => {}
  }, []);

  useEffect(() => {
    if (url && imageRef.current) {
      imageRef.current.src = url
    }
  }, [url]);

  return useMemo(() => (
    [imageRef, loaded === imageRef.current?.src, size]
  ), [imageRef, loaded, size]);
}